import { useGetPriorityFeaturesBulkQuery } from 'pricing-pages-ui-public-app/__generated__/chirp/com/hubspot/feature/store/rpc/PriorityFeaturesRpc.hooks';
import { buildCompareSeatCards } from 'pricing-pages-ui-components/compare-seats/compareSeatsHelpers';
import { getI18nLangLocale } from 'pricing-pages-ui-components/utils/languageUtils';
import Raven from 'raven-js';
import { useCallback, useMemo, useState } from 'react';
import { DEFAULT_CHIRP_TIMEOUT } from '../../constants/chirpDefaults';
import { isAbortedQueryError } from '../../utils/isAbortedQueryError';
import { trackPlanBuilderInteraction } from '../../utils/tracking';
import { getFscCompareSeats } from './publicFscCompareSeatsHelpers';
export function usePublicFscCompareSeats({
  tierOption,
  products,
  primaryPricePerSeat,
  currencyCode
}) {
  const [isOpen, setIsOpen] = useState(false);
  const seats = useMemo(() => getFscCompareSeats(tierOption, products, primaryPricePerSeat), [tierOption, products, primaryPricePerSeat]);
  const productApiNames = useMemo(() => seats.map(seat => seat.apiName), [seats]);
  const handleError = useCallback(error => {
    if (isAbortedQueryError(error)) return;
    Raven.captureException(error, {
      fingerprint: ['failed-to-fetch-fsc-compare-seats-priority-features'],
      extra: {
        productApiNames
      }
    });
  }, [productApiNames]);
  const {
    data,
    loading
  } = useGetPriorityFeaturesBulkQuery({
    variables: {
      productApiNames,
      i18nLangLocale: getI18nLangLocale()
    },
    context: {
      timeout: DEFAULT_CHIRP_TIMEOUT
    },
    onError: handleError,
    skip: !isOpen
  });
  const seatCards = useMemo(() => buildCompareSeatCards(seats, data === null || data === void 0 ? void 0 : data.priorityFeaturesPublic), [seats, data === null || data === void 0 ? void 0 : data.priorityFeaturesPublic]);
  const onOpen = useCallback(() => {
    trackPlanBuilderInteraction({
      component: 'fsc-compare-seats',
      action: 'open',
      apiName: tierOption === null || tierOption === void 0 ? void 0 : tierOption.productApiName,
      productNames: productApiNames,
      activeCurrencyCode: currencyCode
    });
    setIsOpen(true);
  }, [tierOption === null || tierOption === void 0 ? void 0 : tierOption.productApiName, productApiNames, currencyCode]);
  const onClose = useCallback(() => setIsOpen(false), []);
  if (seats.length < 2) return null;
  return {
    isOpen,
    isLoading: loading,
    seatCards,
    currencyCode,
    onOpen,
    onClose
  };
}